import React, { useState, useRef, useEffect } from 'react';
import './Chatbot.css'; // Import your CSS file (create it if you don't have it)
import HrTopicsAndFaqs from '../HRBuddy/HRBuddy';
import { useChat } from '../../hooks/chat/chat';
import { useParams } from 'react-router';

const Chatbot: React.FC = () => {
const {id}= useParams()
    const chatApi= useChat()
  const [messages, setMessages] = useState([
    { sender: 'bot', text: "Hello! I'm AssistBot, your AI assistant. I'm here to help you with any questions about company policies, procedures, or general information. What can I help you with today?" },
    // { sender: 'user', text: "How do I request time off?" },
    // { sender: 'bot', text: "To request time off, follow these steps:\n1. Log into the HR portal\n2. Click on 'Time Off' in the left menu\n3. Select 'New Request'\n4. Fill in the dates and reason\n5. Submit for approval" }
  ]);
  const [userInput, setUserInput] = useState('');
  const messageListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scroll to bottom when new messages are added
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
  }, [messages]);


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userInput.trim() !== '') {
      setMessages([...messages, { sender: 'user', text: userInput }]);
      setUserInput('');
      setMessages((prevMessages) => [...prevMessages, { sender: "bot", text: "Typing..." }]);
    

chatApi.mutate({message:userInput, api_key:id}, {
    onSuccess(chatResponse){
        setMessages((prevMessages) => [...prevMessages, { sender: "bot", text: chatResponse.message }]);
    
    },
    onError(){

      setMessages((prevMessages) => [...prevMessages.filter(x=> x.text!==("Unable to get an answer, please retry..."))]);
    },
    onSettled(){
        setMessages((prevMessages) => [...prevMessages.filter(x=> x.text!==("Typing..."))]);
    
    }
})


      // Simulate bot response (replace with your actual logic/API call)
      setTimeout(() => {
        // const botResponse = getBotResponse(userInput); // Implement this function
        // setMessages((prevMessages) => [...prevMessages, { sender: "bot", text: botResponse }]);
      }, 500); // Small delay for effect
    }
  };

  const getBotResponse = (input: string): string => {
    // Replace this with your actual chatbot logic or API call
    // Example responses (replace with your FAQs and topics):
    const lowerInput = input.toLowerCase();
    if (lowerInput.includes("faq")) {
      return "Here are some FAQs:\n1. How do I reset my password?\n2. What are the company holidays?";
    } else if (lowerInput.includes("topic")) {
      return "Here are some popular topics:\n1. Benefits\n2. Payroll";
    } else if (lowerInput.includes("help")) {
      return "I can help with FAQs, topics, and general inquiries. Try asking a specific question.";
    }
    return input
    // return "I'm still learning! Please provide feedback on my responses so I can improve. Try asking about FAQs or Topics."; // Default response
  };

  const handleQuickAction = (action: string) => {
    setUserInput(action);
  };

  return (
    <div className="p-4">
   
    <div className="container  rounded-md mx-auto p-4  flex flex-col font-sans bg-gray-100">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          <span className="text-xl font-bold mr-2 text-gray-800">AssistBot</span>
          <span className="bg-gray-300 rounded-full h-2 w-2 inline-block"></span>
          <span className="text-sm ml-1 text-gray-600">Online</span>
        </div>
        <div>
          <button className="text-gray-600 hover:text-gray-800 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="mb-4">
        <span className="text-sm font-medium text-gray-700">Suggested</span>
        <div className="mt-2 flex space-x-2">
          <button onClick={() => handleQuickAction("What's the dress code policy?")} className="bg-blue-500 hover:bg-blue-700 text-white font-bold badge badge-primary rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300">What's the dress code policy?</button>
          <button onClick={() => handleQuickAction("How do I update my personal information?")} className="bg-blue-500 hover:bg-blue-700 text-white font-bold badge badge-primary rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300">How do I update my personal information?</button>
          <button onClick={() => handleQuickAction("Where can I find the employee handbook?")} className="bg-blue-500 hover:bg-blue-700 text-white font-bold badge badge-primary rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300">Where can I find the employee handbook?</button>
          {/* <button onClick={() => handleQuickAction("Office Services")} className="bg-blue-500 hover:bg-blue-700 text-white font-bold badge badge-primary rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300">Office Services</button> */}
        </div>
      </div>

      {/* Chat Area */}
      <div className="flex-grow bg-white rounded-lg shadow-md p-4 overflow-y-auto scrollbar-thin" ref={messageListRef} style={{height:400, overflowY:"scroll"}}>
        {messages.map((message, index) => (
          <div key={index} className={`mb-4 ${message.sender === 'user' ? 'flex justify-end' : ''}`}>
            <div className={`bg-${message.sender === 'user' ? 'blue-500 text-white' : 'gray-200 text-gray-800'} rounded-lg p-3 text-sm max-w-3xl`}>
             
              {message.text.split('\n').map((line, i) => (
                <p key={i} className="whitespace-pre-wrap">{line}</p>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Input Area */}
      <form onSubmit={handleSubmit} className="mt-4 flex items-center">
        <input type="text" value={userInput} onChange={handleInputChange} className="input input-bordered input-lg flex-grow border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2" placeholder="Type your message..." />
        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M7.455 2.056a1 1 0 011.49.397c.07.24.22.448.412.602l4 2.667A1 1 0 0113 6.95v9.095a1 1 0 01-.933.998c-.41.065-.772-.257-.933-.66l-4.004-2.669A1 1 0 017 15.05V6.952l-4-2.667a1 1 0 01.072-1.397z" clipRule="evenodd" />
          </svg>
        
        </button>
      </form>
      
<div className="mb-4"></div>

<div className='divider '>
    </div>

      {/* Suggested Prompts */}
      {/* <div className="mt-2 text-xs text-gray-500">Suggested: "What's the dress code policy?" "How do I update my personal information?" "Where can I find the employee handbook?"</div> */}
   
   
   <HrTopicsAndFaqs/>
   
   
    </div>
    </div>
  )
};
export default Chatbot;
